module.exports = __webpack_public_path__ + "img/5.45992312.jpg";